import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shop-around-list-block',
  templateUrl: './shop-around-list-block.component.html',
  standalone: false,
})
export class ShopAroundListBlockComponent {
  @Input() body: any;
}
